export default "__VITE_ASSET__zWiMHsXp__"